export const THEMES = {
  turkuaz: { label: "Turkuaz", bg: "#e6f7f5", sidebar: "#0f2033", header: "#ccf0eb", accent: "#4fd1c5" },
  lacivert: { label: "Lacivert", bg: "#e9eef7", sidebar: "#0b1a3a", header: "#d3dcee", accent: "#7dd3fc" },
  gri: { label: "Açık Gri", bg: "#f1f3f5", sidebar: "#1f2937", header: "#e2e5e9", accent: "#a5b4fc" },
  yesil: { label: "Yeşil", bg: "#ecf7ec", sidebar: "#14321f", header: "#d6ecd6", accent: "#86efac" },
};

export function applyTheme(id) {
  const t = THEMES[id] || THEMES.turkuaz;
  const s = document.documentElement.style;
  s.setProperty("--app-bg", t.bg);
  s.setProperty("--sidebar-bg", t.sidebar);
  s.setProperty("--header-border", t.header);
  s.setProperty("--nav-active", t.accent);
  document.documentElement.dataset.theme = id;
}
